<app-header
        [navbarBrandRouterLink]="['/user/group']"
        [fixed]="true"
        [navbarBrandFull]="{src: 'assets/img/brand/logo.png', width: 150, height: 30, alt: 'かいとりや本舗'}"
        [navbarBrandMinimized]="{src: 'assets/img/brand/sygnet.png', width: 30, height: 30, alt: 'かいとりや本舗'}"
        [sidebarToggler]="'lg'"
        [asideMenuToggler]="false"
        [mobileAsideMenuToggler]="false">
    <ul class="nav navbar-nav ml-auto mr-5">
        <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link d-none d-lg-block" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle>
                <span>{{user.name}}</span>
            </a>
        </li>
    </ul>
</app-header>
<div class="app-body">
    <div class="sidebar">
        <nav class="sidebar-nav">
            <ul class="nav">
                <li class="nav-item d-md-none">
                    <span class="nav-link">{{user.name}}</span>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/order']"><i class="icon-puzzle"></i> 買取</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/bb']"><i class="icon-puzzle"></i> 買取(貿易)</a>
                </li>
                <li class="nav-item d-none d-lg-block">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/analysis']"><i class="icon-puzzle"></i> 買取分析</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/calendar']"><i class="icon-puzzle"></i> カレンダー</a>
                </li>
                <li class="nav-item d-none d-lg-block">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/product-management']"><i class="icon-puzzle"></i> 商品管理</a>
                </li>
                <li class="divider"></li>
                <li *ngIf="hasRole('買取屋管理者')" class="nav-item nav-dropdown d-none d-lg-block" dropdown [autoClose]="false" [isOpen]="true">
                    <a class="nav-link nav-dropdown-toggle" data-toggle="dropdown" dropdownToggle (click)="false"><i class="fa-cog"></i> 管理者メニュー</a>
                    <ul class="nav-dropdown-items" *dropdownMenu>
                        <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/customer-management']"><i class="icon-puzzle"></i> 顧客管理</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/master-management']"><i class="icon-puzzle"></i> マスター管理</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/user-management']"><i class="icon-puzzle"></i> ユーザ管理</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" [routerLink]="['/user/report-management']"><i class="icon-puzzle"></i> レポート管理</a>
                        </li>
                    </ul>
                </li>
                <li class="divider"></li>
                <li class="nav-item">
                    <a class="nav-link" href="#" (click)="logout()"><i class="fa fa-lock"></i> ログアウト</a>
                </li>
                <li class="nav-item" *ngIf="googleEnabled && !isGoogleSignedIn">
                    <a class="nav-link"  (click)="googleSignIn()"><i class="fak"></i> カレンダーログイン</a>
                </li>
                <li class="nav-item" *ngIf="googleEnabled && isGoogleSignedIn">
                    <a class="nav-link"  (click)="googleSignOut()"><i class="fa fa-lock"></i> カレンダーログアウト</a>
                </li>
            </ul>
        </nav>
    </div>
    <main class="main">
        <router-outlet></router-outlet>
    </main>
</div>
<footer class="app-footer">
    <span class="float-xs-right">
        Powered by <a href="https://www.kobe-ap.com/">株式会社アクティブプロモーション</a>「令和２年度補正　ものづくり補助金により作成」
    </span>
</footer>
